import styled from '@emotion/styled'
import { Check } from 'app/components/Icons'
import { FlexBox } from 'app/components/Layout/FlexBox'
import { HeaderContext } from 'app/containers/Header'
import { styles, theme } from 'app/theme'
import { rgba } from 'emotion-rgba'
import React, { memo, useContext } from 'react'

export interface Props {
  modalStatus?: boolean
}

export const Benefits = memo(function Benefits({ modalStatus }: Props) {
  const { benefits, benefitsList } = useContext(HeaderContext) as any

  if (!benefits) {
    return null
  }

  return (
    <Container
      className={modalStatus ? 'open item-benefits' : undefined}
      onClick={(e) => e.stopPropagation()}
    >
      {benefitsList ? (
        <Box>
          {benefits.label ? (
            <BenefitsLabel>{benefits.label}</BenefitsLabel>
          ) : null}
          {benefits.title ? (
            <BenefitsTitle>{benefits.title}</BenefitsTitle>
          ) : null}

          <Items row wrap space="between">
            {benefitsList.map((item: any, index: any) => {
              if (!item) return

              return (
                <Item key={index} row dial={4}>
                  <IconWrap dial={5}>
                    <Check />
                  </IconWrap>
                  {item.title}
                </Item>
              )
            })}
          </Items>
        </Box>
      ) : null}
    </Container>
  )
})

const Box = styled.div`
  padding: 0 3rem;
`

const BenefitsLabel = styled.div`
  ${styles.label}

  color: ${({ theme }) => theme.colors.variants.neutralLight3};
  text-align: center;
  margin-bottom: 2.25rem;

  @media (max-width: 1439px) {
    margin-bottom: 1.25rem;
  }
`

const BenefitsTitle = styled.div`
  ${styles.title.medium}

  text-transform: none;
  color: ${({ theme }) => theme.colors.variants.neutralLight3};
  text-align: center;
  margin-bottom: 3.75rem;

  @media (max-width: 1439px) {
    margin-bottom: 2.25rem;
  }
`
const Items = styled(FlexBox)`
  text-align: left;
`

const Item = styled(FlexBox)`
  ${styles.description.light}

  width: 100%;
  color: ${({ theme }) => theme.colors.variants.neutralLight3};
  padding: 1.125rem 0;
  margin-bottom: 1rem;
  border-bottom: 0.125rem solid
    ${rgba(theme.colors.variants.neutralLight3, 0.1)};

  &:last-of-type {
    margin-bottom: 0;
    border-bottom: none;
  }

  svg {
    width: 0.75rem;
    fill: ${({ theme }) => theme.colors.variants.neutralLight3};
  }

  @media (max-width: 1439px) {
    margin-bottom: 0;
    line-height: 1.125rem;
  }
`

const IconWrap = styled(FlexBox)`
  border-radius: 50%;
  width: 1.75rem;
  height: 1.75rem;
  margin-right: 0.75rem;
  background-color: ${({ theme }) => theme.colors.variants.primaryDark};
`

const Icon = styled.img`
  margin-right: 1.5rem;
`

const Container = styled.div`
  padding: 0 5vw;
  color: ${({ theme }) => theme.colors.variants.neutralLight3};
  overflow: hidden;
  position: relative;
  opacity: 0;
  transition: 0.6s 0.6s ease-in-out;
  &.open {
    opacity: 1;
  }
`
